/* eslint-disable react/require-default-props */
import React from 'react';

import { Container } from './styles';

interface BlurredContentProps {
  children: React.ReactNode;
  className?: string;
}

const BlurredContent: React.FC<BlurredContentProps> = ({ children, className = '' }) => {
  return (
    <Container className={`blurred-content ${className}`} aria-hidden="true">
      {children}
    </Container>
  );
};

export default BlurredContent;
